import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLDARKCLOUDCOVER', label: 'Dark Cloud Cover', lookback: 11, penetration: 0.5 })
